/* Tokyo Reads - tr-header-sync.js (WO-T1b-6, 2026-07-31, SEO-sessie)
   Marker 'tr-compact-was-shown' op body = de compacte header is
   VOLLEDIG ingeschoven geweest (showCompactHeader afgerond) sinds de
   pagina voor het laatst bovenaan stond. Vanaf dat moment schakelt
   tr-header-sync.css de header over op TRANSITIONS (onderbreekbaar,
   geen keyframe-herstart-pop = de dunne-balk-glitch); balk/filters
   volgen via template-collection.css. Reset zodra has-scrolled weg is.
   Vanaf-de-top blijft instant (spookbalkje-les, tr-custom.css).
   Leest uitsluitend bestaande theme.js-classes; guarded writes
   (classList muteert het attribuut ook zonder wijziging - lus-les). */
(function () {
  var MARK = 'tr-compact-was-shown';
  function clearAtTop() {
    var b = document.body;
    if (!b.classList.contains('has-scrolled') && b.classList.contains(MARK)) {
      b.classList.remove(MARK);
    }
  }
  if (!document.body) return;
  document.addEventListener('animationend', function (e) {
    if (e.animationName === 'showCompactHeader' &&
        !document.body.classList.contains(MARK)) {
      document.body.classList.add(MARK);
    }
  }, true);
  new MutationObserver(clearAtTop).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  clearAtTop();

  /* tr-topzone (01-10): de compacte header is via tr-header-sync.css even
     hoog als de header bovenaan (--header-height). theme.js rekent met
     window.stickyHeaderHeight (head.liquid: 60) voor de drempel, de
     achtergrondhoogte van het menu en scroll-offsets; laat dat getal de
     echte hoogte volgen, anders eindigt de menu-achtergrond 4 px te hoog.
     Alleen schrijven als het een geldig getal is (guarded write). */
  var syncStickyHeight = function () {
    var h = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
    if (h > 0 && window.stickyHeaderHeight !== h) {
      window.stickyHeaderHeight = h;
    }
  };
  syncStickyHeight();
  document.addEventListener('theme:vars', syncStickyHeight);
  document.addEventListener('theme:resize', syncStickyHeight);
  window.addEventListener('load', syncStickyHeight);

  /* Stuck-detector voor de collectie-balk: het naadvlak (::before in
     template-collection.css) mag ALLEEN bestaan als de balk vastgeplakt
     zit - in flow-positie dekte het vlak de collectie-beschrijving af
     (Dandadan-vondst 31-07). GEEN IntersectionObserver met bevroren
     rootMargin (05-08-les: init-hoogte wijkt op mobiel af van de live
     situatie -> detector vuurde nooit): live-geometrie-check op het
     bestaande theme:scroll-kanaal, sticky-offset per check uit computed
     style gelezen (zelfcorrigerend voor adresbalk/resize). Guarded
     toggle (lus-les). rect.top telt de hide-transform mee: -60 blijft
     onder de drempel, dus stuck blijft staan tijdens het dansje. */
  var bar = document.querySelector('.collection__sticky-bar');
  if (bar) {
    var stuckCheck = function () {
      var stickyTop = parseFloat(getComputedStyle(bar).top) || 0;
      var stuck = bar.getBoundingClientRect().top <= stickyTop + 1;
      if (bar.classList.contains('tr-bar-stuck') !== stuck) {
        bar.classList.toggle('tr-bar-stuck', stuck);
      }
    };
    document.addEventListener('theme:scroll', stuckCheck);
    document.addEventListener('theme:resize', stuckCheck);
    window.addEventListener('load', stuckCheck);
    stuckCheck();
  }

  /* tr-topzone stap 2 (01-10, Jans opnames 30-09/01-10 en test op review 13):
     stap 1 (gelijke maten) haalde de sprong van 11 px weg, maar in de
     bovenste zone schoof de compacte header nog op zijn eigen timer
     (0,3 s) terwijl de gereserveerde witte strook met de vinger
     meekwam: logo en menu kwamen later aan dan de witte balk. Hier volgt
     de header de pagina zodra scrollY kleiner is dan de headerhoogte en
     has-scrolled nog staat: transform = max(huidige schuifstand, -scrollY).
     max = nooit terugtrekken; loopt de schuif achter op de pagina, dan
     springt hij in de bewegingsrichting bij (onzichtbaar), daarna beweegt
     hij frame voor frame mee tot de omslag op 0, die met gelijke maten
     onzichtbaar is. Native scroll-event (theme:scroll komt te laat, zie de
     opname: de omslag kwam 3 beelden na het bereiken van de top). Inline
     stijlen winnen van de animatie/transition van thema en tr-header-sync;
     buiten de zone of na de omslag worden ze weer gewist (guarded). */
  var fixedHeader = document.querySelector('.site-header--fixed');
  if (fixedHeader) {
    var zoneH = 0;
    var readZoneH = function () {
      zoneH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || fixedHeader.offsetHeight || 64;
    };
    var topZone = function () {
      var b = document.body;
      var inZone = b.classList.contains('tr-topzone');
      var s = window.scrollY || document.documentElement.scrollTop || 0;
      if (!zoneH) readZoneH();
      if (b.classList.contains('has-scrolled') && s < zoneH) {
        var ty = 0;
        var m = getComputedStyle(fixedHeader).transform;
        if (m && m !== 'none') {
          var parts = m.match(/matrix\(([^)]+)\)/);
          if (parts) ty = parseFloat(parts[1].split(',')[5]) || 0;
        }
        var target = Math.max(ty, -s);
        fixedHeader.style.animation = 'none';
        fixedHeader.style.transition = 'none';
        fixedHeader.style.transform = 'translateY(' + target + 'px)';
        if (!inZone) b.classList.add('tr-topzone');
      } else if (inZone) {
        fixedHeader.style.animation = '';
        fixedHeader.style.transition = '';
        fixedHeader.style.transform = '';
        b.classList.remove('tr-topzone');
      }
    };
    /* Buiten de zone kost dit per scroll-event alleen twee klassenchecks en
       scrollY; de headerhoogte wordt gecachet en volgt theme:vars/resize. */
    readZoneH();
    document.addEventListener('theme:vars', readZoneH);
    document.addEventListener('theme:resize', readZoneH);
    window.addEventListener('scroll', topZone, { passive: true });
    new MutationObserver(topZone).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
})();
